import { AnalyticsColumn } from "./analytics-column";

export class AnalyticsParameter extends AnalyticsColumn {
    mandatory:boolean;
    queryId:string;
    value:any;
}
